import type { Filter } from '@atlassian/jira-boards-main/src/model/index.tsx';
import type { Project } from '@atlassian/jira-common-directory-v2/src/model/shareable-entities/index.tsx';
import type {
	FilterToParamTransformer,
	ParamToFilterTransformer,
} from '@atlassian/jira-common-directory-v2/src/query-param-adapter/model/index.tsx';
import type { User } from '@atlassian/jira-user-picker/src/model/index.tsx';

export const AGILITY_PARAM_VALUE = 'agility';

const transformSelectedProject = (input?: string): Project | undefined =>
	input && input !== undefined
		? {
				value: input,
			}
		: undefined;

const transformSelectedUser = (input?: string): User | undefined =>
	input && input !== undefined
		? {
				accountId: input,
				value: input,
				displayName: '',
			}
		: undefined;

export const filterToParams: FilterToParamTransformer<Filter> = ({
	project,
	text,
	user,
}: Filter = {}) => ({
	contains: text || undefined,
	projectLocation: project?.value || undefined,
	accountIdLocation: user?.accountId || undefined,
});

export const filterFromParams: ParamToFilterTransformer<Filter> = (params) => ({
	text: params.contains || undefined,
	project: transformSelectedProject(params.projectLocation),
	user: transformSelectedUser(params.accountIdLocation),
});
